export default __webpack_public_path__ + "static/media/Aquawax_Regular-trial.4fb7b53e.ttf";